export type ChallengeMetric = 'average_score' | 'sessions_completed' | 'xp_earned'

export const CHALLENGE_METRICS: readonly ChallengeMetric[] = [
  'sessions_completed',
  'average_score',
  'xp_earned',
]

/** Durées imposées par les spécifications § 6.3. */
export const CHALLENGE_DURATIONS = [3, 7, 14] as const

export type ChallengeStatus = 'active' | 'resolved' | 'cancelled'

export type ParticipantStatus = 'invited' | 'accepted' | 'declined' | 'left'

export interface ChallengeParticipant {
  username: string | null
  status: ParticipantStatus
  score: number
}

export interface Challenge {
  id: string
  course_id: string | null
  course_title: string | null
  subject: string | null
  metric: ChallengeMetric
  duration_days: number
  ends_at: string
  status: ChallengeStatus
  winner: string | null
  my_status: ParticipantStatus | null
  is_creator: boolean
  participants: ChallengeParticipant[]
}

export interface CreateChallengePayload {
  course_id: string
  metric: ChallengeMetric
  duration_days: number
}
